import { db } from "./firebase";

export function getQuizVideos() {
  return db.collection("ARPvariables").doc("WebVariables");
}

export function getLoanVar() {
  //ToolsWhatIsLoanVariables
  return db.collection("ARPvariables").doc("ToolsWhatIsLoanVariables");
}
export function getLoanFilVar() {
  return db.collection("ARPvariables").doc("ToolsWhatIsLoanVariables-Fil");
}

export function updatedatabase(logData) {
  const batch = db.batch();
  const logsRef = db
    .collection("ARPvariables")
    .doc("ToolsWhatIsSavingsVariables-Fil");
  batch.set(logsRef, logData);
  return batch.commit();
}
